const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;

const emailRules = {
  sv: [
    v => !!v || "Obligatoriskt fält",
    v => emailRegex.test(v) || "Felaktig e-postadress"
  ],
  en: [v => !!v || "Required field", v => emailRegex.test(v) || "Invalid Email"],
  ar: [v => !!v || "Required field", v => emailRegex.test(v) || "Invalid Email"]
};

const requiredRule = {
  sv: [v => !!v || "Obligatoriskt fält"],
  en: [v => !!v || "Required field"],
  ar: [v => !!v || "Required field"]
};

export { emailRules, requiredRule };
